<template>
  <div class="project-wrapper" ref="scroller">
    <div class="project-titlewrapper">
      <div class="project-title__tc">
        <div class="project-title__tc-counter">
          <div ref="counter" class="project-title__tc-counter-clipper">
            {{ titleInfo.counter }}/{{ projectsCount }}
          </div>
        </div>
        <fitty :options="options">
          <template v-slot:content>
            <div class="project-title__tc-title">
              <div ref="title" class="project-title__tc-title-clipper">
                {{ titleInfo.title }}
              </div>
            </div>
          </template>
        </fitty>
        <div class="project-title__tc-category">
          <div class="project-title__tc-category-clipper">
            <div ref="txtitmcat" class="clipper">
              {{ titleInfo.textitem }} {{ titleInfo.category }}
            </div>
          </div>
          <div class="project-title__tc-link clip">
            <div ref="visit" class="project-title__tc-link">
              <div class="project-title__tc-link-text">Visit site</div>
              <a :href="titleInfo.link" taget="_blank">
                <div class="project-title__tc-link-icon"></div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="project-title__bc">
        <div class="project-title__bc-content clip">
          <div ref="infoBlock" class="clipper">
            <hr class="project-line" />
            <p class="project-lineshift">{{ titleInfo.description.title }}</p>
            <p>{{ titleInfo.description.subtitle1 }}</p>
            <p>{{ titleInfo.description.subtitle2 }}</p>
            <p>{{ titleInfo.description.subtitle3 }}</p>
            <p v-if="titleInfo.description.subtitle4">
              {{ titleInfo.description.subtitle4 }}
            </p>
            <p id="link-arrow">
              <a
                :href="'https://' + titleInfo.description.link"
                target="_blank"
              >
                {{ titleInfo.description.link }}
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="project-content clip" ref="cont">
      <div ref="images" class="clipper">
        <div
          class="project-content__image"
          ref="imgs"
          v-for="(item, index) in imagesDisplay"
          :key="index"
        >
          <div
            class="project-content__desc"
            v-if="index === 1 && titleInfo.text != ''"
          >
            <div
              class="project-content__desc-text"
              v-html="titleInfo.text"
            ></div>
          </div>
          <div class="project-content__imagebox">
            <img :src="item" alt="" :class="{ 'first-image': index === 0 }" />
            <div
              class="project-content__imagedesc"
              v-html="titleInfo.captions[index]"
            ></div>
          </div>
        </div>
        <div v-if="videosDisplay != ''">
          <div
            class="project-content__image"
            ref="imgs"
            v-for="(item, index) in videosDisplay"
            :key="index"
          >
            <div class="project-content__imagebox">
              <video autoplay loop muted playsinline>
                <source :src="item" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
        <div v-if="titleInfo.externalLinks != '' && ismobile == false">
          <div
            class="project-content__iframe"
            v-for="(item, index) in titleInfo.externalLinks"
            :key="index"
          >
            <iframe
              style="overflow-y: none; -webkit-overflow-scrolling: touch; display:block; vertical-align:top;"
              :src="item"
            ></iframe>
          </div>
        </div>
        <div
          class="project-content__desc"
          v-if="titleInfo.title === 'ubisoft' && titleInfo.text != ''"
        >
          <div class="project-content__desc-text" v-html="titleInfo.text"></div>
        </div>
      </div>
    </div>

    <div
      v-if="lastProject === false && nextProject.title !== ''"
      class="project-footer"
    >
      <div class="project-footer__textitem">
        <div ref="bottomtextitem" class="project-footer__textitem-i">
          {{ titleInfo.textitem }}
        </div>
      </div>
      <div class="project-footer__content" @click="openNextProject">
        <div class="clipper">
          <div ref="nextproj" class="project-footer__content-next">
            Next Project
          </div>
        </div>
        <fitty :options="options">
          <template v-slot:content>
            <div class="clipper">
              <div ref="nexttitle" class="project-footer__content-title">
                {{ nextProject.title }}
              </div>
            </div>
          </template>
        </fitty>
        <div class="clipper">
          <div ref="nextcat" class="project-footer__content-cat">
            {{ nextProject.textitem }} {{ nextProject.cat }}
          </div>
        </div>
        <div class="clipper project-footer__arrow">
          <div ref="nextarrow" id="contentEnd">→</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*eslint-disable */
import projData from '../../public/output.json';
import { gsap } from 'gsap';
import SplitText from 'gsap/SplitText';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(SplitText, ScrollTrigger);

export default {
  name: 'ProjectComponent',
  props: {
    project: '',
    from: String,
    index: Number,
    projectDataProp: '',
  },
  data: function() {
    return {
      ismobile: '',
      projectsList: '',
      projectsCount: 0,
      titleInfo: {
        textitem: '',
        category: '',
        counter: '',
        title: '',
        link: '',
        description: {},
        text: '',
        externalLinks: '',
        captions: {},
      },
      options: {
        minSize: 100,
        maxSize: 500,
      },
      nextProjectIndex: '',
      nextProject: {
        title: '',
        cat: '',
        textitem: '',
      },
      lastProject: false,
      storeVel: '',
      imagesDisplay: [],
      videosDisplay: [],
      descriptions: {},

      backbuttonPressed: false,
    };
  },
  beforeRouteLeave(to, from, next) {
    var tl = gsap.timeline();
    tl.to(this.$refs.counter, {
      x: -this.$refs.counter.clientWidth,
      duration: 0.75,
    });
    tl.to(
      this.$refs.title,
      {
        x: -this.$refs.title.clientWidth,
        duration: 0.75,
      },
      '-=.75'
    );
    tl.to(
      this.$refs.txtitmcat,
      {
        x: -this.$refs.txtitmcat.clientWidth,
        duration: 0.75,
      },
      '-=.75'
    );
    tl.to(
      this.$refs.visit,
      {
        x: -this.$refs.visit.clientWidth,
        duration: 0.75,
      },
      '-=.75'
    );
    tl.to(
      this.$refs.infoBlock,
      {
        x: -this.$refs.infoBlock.clientWidth,
        duration: 0.75,
      },
      '-=.75'
    );

    if (this.lastProject === false && this.nextProject.title !== '') {
      tl.to(
        this.$refs.bottomtextitem,
        {
          x: -this.$refs.bottomtextitem.clientWidth,
          duration: 0.75,
        },
        '-=.75'
      );
      tl.to(
        this.$refs.nextproj,
        {
          x: -this.$refs.nextproj.clientWidth,
          duration: 0.75,
        },
        '-=.75'
      );
      tl.to(
        this.$refs.bottomtextitem,
        {
          x: -this.$refs.bottomtextitem.clientWidth,
          duration: 0.75,
        },
        '-=.75'
      );
      tl.to(
        this.$refs.nextproj,
        {
          x: -this.$refs.nextproj.clientWidth,
          duration: 0.75,
        },
        '-=.75'
      );
      tl.to(
        this.$refs.nexttitle,
        {
          x: -this.$refs.nexttitle.clientWidth,
          duration: 0.75,
        },
        '-=.75'
      );
      tl.to(
        this.$refs.nextcat,
        {
          x: -this.$refs.nextcat.clientWidth,
          duration: 0.75,
        },
        '-=.75'
      );
      tl.to(
        this.$refs.nextarrow,
        {
          x: -this.$refs.nextarrow.clientWidth,
          duration: 0.75,
        },
        '-=.75'
      );
    }

    tl.to(
      this.$refs.images,
      {
        x: -this.$refs.images.clientWidth,
        duration: 0.75,
      },
      '-=.75'
    ).then(() => {
      next();
    });
  },
  created() {
    this.ismobile = window.isMobile;

    window.onpopstate = (e) => {
      this.fetchBackData();
    };

    let x = projData[this.project];
    this.imagesDisplay = x['images'];
    if (x['video'] != '') {
      this.videosDisplay = x['video'];
    }
    this.fetchData();
  },
  mounted() {
    this.projectsCount = ('0' + Object.values(projData).length).slice(-2);
    if (this.from == 'push') {
      this.animateIn();
    }
  },
  methods: {
    // getCaption(index) {
    //   console.log(this.titleInfo.captions.caption + index.toString());
    //   return 'titleInfo.captions.caption + index.toString()';
    // },
    fetchBackData() {
      const data = this.projectsList[1];
      if (data) {
        let info = this.titleInfo;
        info.textitem = data.textitem;
        info.category = data.category;
        info.counter = data.counter;
        info.title = data.title;
        info.description = data.description;
        info.text = data.text;
        info.link = data.link;
        info.externalLinks = data.externalLinks;
        this.nextProjectIndex = data.counter;
      }
    },
    fetchData() {
      if (this.projectDataProp != undefined) {
        this.projectsList = this.projectDataProp[this.project];

        let collection = this.projectsList.info;
        let info = this.titleInfo;
        info.textitem = collection.textitem;
        info.category = collection.category;
        info.counter = collection.counter;
        info.title = collection.title;
        info.description = collection.description;
        info.text = collection.text;
        info.link = collection.link;
        info.externalLinks = collection.externalLinks;
        this.nextProjectIndex = collection.counter;

        if (collection.captions) {
          info.captions = collection.captions;
        }

        this.getNextProject('push');
      } else {
        this.projectsList = Object.values(projData[this.project]);
        console.log(this.projectsList, 'PLL');
        fetch(this.projectsList[1])
          .then((r) => r.json())
          .then((res) => {
            this.projectsList[1] = res;
            let info = this.titleInfo;
            info.textitem = res.textitem;
            info.category = res.category;
            info.counter = res.counter;
            info.title = res.title;
            info.description = res.description;
            info.text = res.text;
            info.link = res.link;
            info.externalLinks = res.externalLinks;
            this.nextProjectIndex = res.counter;

            if (res.captions) {
              info.captions = res.captions;
            }
          })
          .catch(function() {
            console.log();
          });
      }
    },
    animateIn() {
      var tl = gsap.timeline();
      tl.from(this.$refs.counter, {
        x: this.$refs.counter.clientWidth,
        duration: 0.75,
      });
      tl.from(
        this.$refs.title,
        {
          x: this.$refs.title.clientWidth,
          duration: 0.75,
        },
        '-=.75'
      );
      tl.from(
        this.$refs.txtitmcat,
        {
          x: this.$refs.txtitmcat.clientWidth,
          duration: 0.75,
        },
        '-=.75'
      );
      tl.from(
        this.$refs.visit,
        {
          x: this.$refs.visit.clientWidth,
          duration: 0.75,
        },
        '-=.75'
      );
      tl.from(
        this.$refs.infoBlock,
        {
          x: this.$refs.infoBlock.clientWidth,
          duration: 0.75,
        },
        '-=.75'
      );
      tl.from(
        this.$refs.images,
        {
          x: this.$refs.images.clientWidth,
          duration: 0.75,
        },
        '-=.75'
      );
    },
    animateOut(dir) {
      var tl = gsap.timeline();
      tl.to(this.$refs.counter, {
        x: -this.$refs.counter.clientWidth,
        duration: 0.75,
      });
      tl.to(
        this.$refs.title,
        {
          x: -this.$refs.title.clientWidth,
          duration: 0.75,
        },
        '-=.75'
      );
      tl.to(
        this.$refs.txtitmcat,
        {
          x: -this.$refs.txtitmcat.clientWidth,
          duration: 0.75,
        },
        '-=.75'
      );
      tl.to(
        this.$refs.visit,
        {
          x: -this.$refs.visit.clientWidth,
          duration: 0.75,
        },
        '-=.75'
      );
      tl.to(
        this.$refs.infoBlock,
        {
          x: -this.$refs.infoBlock.clientWidth,
          duration: 0.75,
        },
        '-=.75'
      );
      tl.to(
        this.$refs.images,
        {
          x: -this.$refs.images.clientWidth,
          duration: 0.75,
        },
        '-=.75'
      );
      tl.to(
        this.$refs.bottomtextitem,
        {
          x: -this.$refs.bottomtextitem.clientWidth,
          duration: 0.75,
        },
        '-=.75'
      );
      tl.to(
        this.$refs.nextproj,
        {
          x: -this.$refs.nextproj.clientWidth,
          duration: 0.75,
        },
        '-=.75'
      );
      tl.to(
        this.$refs.nexttitle,
        {
          x: -this.$refs.nexttitle.clientWidth,
          duration: 0.75,
        },
        '-=.75'
      );
      tl.to(
        this.$refs.nextcat,
        {
          x: -this.$refs.nextcat.clientWidth,
          duration: 0.75,
        },
        '-=.75'
      );
      tl.to(
        this.$refs.nextarrow,
        {
          x: -this.$refs.nextarrow.clientWidth,
          duration: 0.75,
        },
        '-=.75'
      ).then(() => {
        this.$router
          .push({
            name: 'project',
            params: {
              project: this.nextProject.title,
              from: 'push',
              index: this.index + 1,
              projectDataProp: projData,
            },
          })
          .catch((err) => {});
      });
    },
    animateScroll() {
      const container = document.getElementById('app');
      size();
      function size() {
        const height = container.clientHeight;
        gsap.set(document.body, { height });
        gsap.fromTo(
          container,
          { y: 0 },
          {
            y: -(height - document.documentElement.clientHeight),
            overwrite: 'auto',
            scrollTrigger: {
              trigger: document.body,
              start: 'top top',
              end: 'top bottom',
              markers: true,
              scrub: 1,
            },
          }
        );
      }
      ScrollTrigger.create({
        trigger: document.body,
        onUpdate: (self) => {
          const skewVal = (-self.getVelocity() / 2000) * 1.5;
          gsap.to(this.$refs.imgs, {
            skewY: skewVal,
            duration: 0.1,
            overwrite: 'auto',
            onComplete: () => {
              gsap.to(this.$refs.imgs, {
                skewY: 0,
                duration: 0.25,
                overwrite: 'auto',
              });
            },
          });
        },
      });
    },
    getNextProject(source) {
      if (this.nextProjectIndex < 10) {
        this.nextProjectIndex = this.nextProjectIndex.slice(-1);
      }
      let tempProjData = Object.values(projData);
      if (this.nextProjectIndex != tempProjData.length) {
        if (source == 'notpush') {
          let tempNextProj = Object.values(tempProjData[this.nextProjectIndex]);
          tempNextProj.forEach((el) => {
            fetch(el)
              .then((r) => r.json())
              .then((res) => {
                this.nextProject.title = res.title;
                this.nextProject.cat = res.category;
                this.nextProject.textitem = res.textitem;
              });
          });
        } else {
          let temp = Object.values(projData);
          let store = temp[this.nextProjectIndex].info;
          this.nextProject.title = store.title;
          this.nextProject.cat = store.category;
          this.nextProject.textitem = store.textitem;
        }
      } else {
        this.lastProject = true;
      }
    },
    openNextProject() {
      this.animateOut();
    },
  },
};
</script>
